import React, { useState, useEffect } from "react";
import axios from "axios";

const Gateway = () => {
  // --- STATES (UNCHANGED) ---
  const [RazorPayout, setRazorpayout] = useState(true);
  const [RazorDeposit, setRazorDeposit] = useState(true);
  const [RazorpayAuto, setRazorpayAuto] = useState(false);
  const [RazorPayKey, setRazorpayKey] = useState("");
  const [RazorPaySecretKey, setRazorpaysecretKey] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [decentroPayout, setdecentropayout] = useState(true);
  const [decentroDeposit, setdecentroDeposit] = useState(true);
  const [decentroAuto, setdecentroAuto] = useState(false);
  const [settingId, setSettingId] = useState("");
  const [isCashFreeActive, setIsCashFreeActive] = useState(false);
  const [isPhonePeActive, setIsPhonePeActive] = useState(false);
  const [isRazorPayActive, setIsRazorPayActive] = useState(false);
  const [isDecentroActive, setIsDecentroActive] = useState(false);
  const [isManualPaymentActive, setIsManualPaymentActive] = useState(false);
  const [isManualUPIQR, setIsManualUPIQR] = useState("");
  const [isManualUPIid, setIsManualUPIid] = useState("");
  const [isUpiGatewayActive, setIsUpiGatewayActive] = useState(false);
  const [isMypayActive, setIsMypayActive] = useState(false);
  const [isManualPayoutActive, setIsManualPayoutActive] = useState(false);
  const [isManualBankPayoutActive, setIsManualBankPayoutActive] = useState(false);
  const [isCashFreePayoutActive, setIsCashFreePayoutActive] = useState(false);
  const [isRazorPayPayoutActive, setIsRazorPayPayoutActive] = useState(false);
  const [isDecentroPayoutActive, setIsDecentroPayoutActive] = useState(false);
  const [maxAutopayAmt, setMaxAutopayAmt] = useState(0);
  const [isMypayPayoutActive, setIsMypayPayoutActive] = useState(false);
  const [isMypayPayoutBankActive, setIsMypayPayoutBankActive] = useState(false);
  const [isDecentroPayoutAuto, setIsDecentroPayoutAuto] = useState(false);
  const [isMypayPayoutAuto, setIsMypayPayoutAuto] = useState(false);
  const [isRazorPayPayoutAuto, setIsRazorPayPayoutAuto] = useState(false);
  const [UpiGatewayKey, setUpiGatewayKey] = useState("");
  const [UpiGatewayReturnUrl, setUpiGatewayReturnUrl] = useState("");

  const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  const baseUrl = nodeMode === "development" ? backendLocalApiUrl : backendLiveApiUrl;

  // --- FETCH DATA (UNCHANGED) ---
  useEffect(() => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    axios.get(baseUrl + "gatewaysettings/data", { headers })
      .then((res) => {
        setSettingId(res.data._id ? res.data._id : '');
        setRazorpayout(res.data.RazorPayout);
        setRazorDeposit(res.data.RazorDeposit);
        setRazorpayAuto(res.data.RazorpayAuto);
        setdecentropayout(res.data.decentroPayout);
        setdecentroDeposit(res.data.decentroDeposit);
        setdecentroAuto(res.data.decentroAuto);
        setRazorpayKey(res.data.RazorPayKey);
        setRazorpaysecretKey(res.data.RazorPaySecretKey);
        setAccountName(res.data.AccountName);
        setIsCashFreeActive(res.data.isCashFreeActive);
        setIsPhonePeActive(res.data.isPhonePeActive);
        setIsRazorPayActive(res.data.isRazorPayActive);
        setIsDecentroActive(res.data.isDecentroActive);
        setIsManualPaymentActive(res.data.isManualPaymentActive);
        setIsManualUPIQR(res.data.isManualUPIQR);
        setIsManualUPIid(res.data.isManualUPIid);
        setIsUpiGatewayActive(res.data.isUpiGatewayActive);
        setIsMypayActive(res.data.isMypayActive);
        setIsManualPayoutActive(res.data.isManualPayoutActive);
        setIsManualBankPayoutActive(res.data.isManualBankPayoutActive);
        setIsCashFreePayoutActive(res.data.isCashFreePayoutActive);
        setIsRazorPayPayoutActive(res.data.isRazorPayPayoutActive);
        setIsDecentroPayoutActive(res.data.isDecentroPayoutActive);
        setMaxAutopayAmt(res.data.maxAutopayAmt);
        setIsMypayPayoutActive(res.data.isMypayPayoutActive);
        setIsMypayPayoutBankActive(res.data.isMypayPayoutBankActive);
        setIsDecentroPayoutAuto(res.data.isDecentroPayoutAuto);
        setIsRazorPayPayoutAuto(res.data.isRazorPayPayoutAuto);
        setIsMypayPayoutAuto(res.data.isMypayPayoutAuto);
        setUpiGatewayKey(res.data.UpiGatewayKey || "");
        setUpiGatewayReturnUrl(res.data.UpiGatewayReturnUrl || "");
      });
  }, [baseUrl]);

  // --- SUBMIT DATA (UNCHANGED) ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const response = await axios.post(
      baseUrl + `gatewaysettings`,
      {
        settingId, RazorPayout, RazorDeposit, RazorpayAuto, decentroPayout, decentroDeposit, decentroAuto, RazorPayKey, RazorPaySecretKey, AccountName, isCashFreeActive, isPhonePeActive, isRazorPayActive, isDecentroActive, isManualPaymentActive, isManualUPIQR, isManualUPIid, isUpiGatewayActive, isMypayActive, isManualPayoutActive, isManualBankPayoutActive, isCashFreePayoutActive, isRazorPayPayoutActive, isDecentroPayoutActive, maxAutopayAmt, isMypayPayoutActive, isMypayPayoutBankActive, isDecentroPayoutAuto, isRazorPayPayoutAuto, isMypayPayoutAuto, UpiGatewayKey, UpiGatewayReturnUrl
      },
      { headers }
    );
    if(response.data.status === 'success'){
      alert("Settings submitted successfully");
    }else{
      alert("Settings Not Submitted");
    }
  };

  return (
    <div className="gateway-container">
      <style>{`
        .gateway-container { font-family: 'Poppins', sans-serif; padding-top: 20px; }
        .gateway-card { 
            background: #ffffff; border-radius: 20px; 
            box-shadow: 0 8px 25px rgba(0,0,0,0.05); margin-bottom: 30px; 
            border: 1px solid #edf2f7; overflow: hidden;
        }
        .gateway-card-header { 
            background: #f8faff; padding: 15px 25px; 
            border-bottom: 1px solid #edf2f7; display: flex; align-items: center; 
        }
        .gateway-card-header h5 { margin: 0; color: #57155a; font-weight: 800; font-size: 1rem; }
        .form-body { padding: 25px; }
        .label-custom { font-weight: 700; color: #4a5568; margin-bottom: 8px; font-size: 0.85rem; }
        
        .select-modern { 
            border: 2px solid #edf2f7; border-radius: 12px; height: 45px; 
            font-weight: 600; transition: 0.3s; cursor: pointer;
        }
        .select-modern:focus { border-color: #57155a; box-shadow: none; }
        
        .input-modern { 
            border: 2px solid #edf2f7; border-radius: 12px; padding: 10px 15px; 
            font-weight: 600; transition: 0.3s;
        }
        .input-modern:focus { border-color: #57155a; box-shadow: none; }

        .submit-gateway-btn {
            background: linear-gradient(45deg, #e74c3c, #c0392b); color: white;
            border: none; padding: 15px 40px; border-radius: 15px;
            font-weight: 800; text-transform: uppercase; width: 100%;
            transition: 0.4s; cursor: pointer; margin-top: 20px;
        }
        .submit-gateway-btn:hover { transform: translateY(-3px); box-shadow: 0 10px 20px rgba(192, 57, 43, 0.3); }
        
        .section-divider { height: 1px; background: #edf2f7; margin: 20px 0; }
      `}</style>

      <div className="d-flex align-items-center mb-4">
        <div style={{width: '5px', height: '30px', background: '#57155a', marginRight: '15px', borderRadius: '10px'}}></div>
        <h4 className="m-0" style={{fontWeight: 900, color: '#2d3436'}}>PAYMENT GATEWAY CONTROLS</h4>
      </div>

      <form onSubmit={handleSubmit}>
        
        {/* RAZORPAY CARD */}
        <div className="gateway-card">
          <div className="gateway-card-header"><h5>💳 RAZORPAY SETTINGS</h5></div>
          <div className="form-body">
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="label-custom">Payout Status</label>
                <select className="form-control select-modern" value={RazorPayout} onChange={(e) => setRazorpayout(e.target.value === 'true')}>
                  <option value="true">✅ Enabled</option>
                  <option value="false">❌ Disabled</option>
                </select>
              </div>
              <div className="col-md-4 mb-3">
                <label className="label-custom">Deposit Status</label>
                <select className="form-control select-modern" value={RazorDeposit} onChange={(e) => setRazorDeposit(e.target.value === 'true')}>
                  <option value="true">✅ Enabled</option>
                  <option value="false">❌ Disabled</option>
                </select>
              </div>
              <div className="col-md-4 mb-3">
                <label className="label-custom">Auto Processing</label>
                <select className="form-control select-modern" value={RazorpayAuto} onChange={(e) => setRazorpayAuto(e.target.value === 'true')}>
                  <option value="true">✅ Enabled</option>
                  <option value="false">❌ Disabled</option>
                </select>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 mb-3"><label className="label-custom">RazorPay Key</label><input className="form-control input-modern" type="text" value={RazorPayKey} onChange={(e) => setRazorpayKey(e.target.value)} /></div>
              <div className="col-md-4 mb-3"><label className="label-custom">Secret Key</label><input className="form-control input-modern" type="text" value={RazorPaySecretKey} onChange={(e) => setRazorpaysecretKey(e.target.value)} /></div>
              <div className="col-md-4 mb-3"><label className="label-custom">Account Name</label><input className="form-control input-modern" type="text" value={AccountName} onChange={(e) => setAccountName(e.target.value)} /></div>
            </div>
          </div>
        </div>

        {/* DECENTRO CARD */}
        <div className="gateway-card">
          <div className="gateway-card-header"><h5>🏦 DECENTRO SETTINGS</h5></div>
          <div className="form-body row">
            <div className="col-md-4 mb-3">
              <label className="label-custom">Payout Status</label>
              <select className="form-control select-modern" value={decentroPayout} onChange={(e) => setdecentropayout(e.target.value === 'true')}>
                <option value="true">✅ Enabled</option>
                <option value="false">❌ Disabled</option>
              </select>
            </div>
            <div className="col-md-4 mb-3">
              <label className="label-custom">Deposit Status</label>
              <select className="form-control select-modern" value={decentroDeposit} onChange={(e) => setdecentroDeposit(e.target.value === 'true')}>
                <option value="true">✅ Enabled</option>
                <option value="false">❌ Disabled</option>
              </select>
            </div>
            <div className="col-md-4 mb-3">
              <label className="label-custom">Decentro Auto</label>
              <select className="form-control select-modern" value={decentroAuto} onChange={(e) => setdecentroAuto(e.target.value === 'true')}>
                <option value="true">✅ Enabled</option>
                <option value="false">❌ Disabled</option>
              </select>
            </div>
          </div>
        </div>

        {/* ACTIVE GATEWAYS & MANUAL UPI */}
        <div className="gateway-card">
          <div className="gateway-card-header"><h5>⚙️ SYSTEM GATEWAY TOGGLES</h5></div>
          <div className="form-body">
            <div className="row">
              <div className="col-md-3 mb-3"><label className="label-custom">CashFree</label><select className="form-control select-modern" value={isCashFreeActive} onChange={(e) => setIsCashFreeActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">PhonePe</label><select className="form-control select-modern" value={isPhonePeActive} onChange={(e) => setIsPhonePeActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">RazorPay</label><select className="form-control select-modern" value={isRazorPayActive} onChange={(e) => setIsRazorPayActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">Decentro</label><select className="form-control select-modern" value={isDecentroActive} onChange={(e) => setIsDecentroActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">Manual Pay</label><select className="form-control select-modern" value={isManualPaymentActive} onChange={(e) => setIsManualPaymentActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">UPI Gateway</label><select className="form-control select-modern" value={isUpiGatewayActive} onChange={(e) => setIsUpiGatewayActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">MyPay</label><select className="form-control select-modern" value={isMypayActive} onChange={(e) => setIsMypayActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
            </div>
            <div className="section-divider"></div>
            <div className="row mt-3">
              <div className="col-md-6 mb-3"><label className="label-custom">Manual UPI QR (URL/Link)</label><input className="form-control input-modern" type="text" value={isManualUPIQR} onChange={(e) => setIsManualUPIQR(e.target.value)} /></div>
              <div className="col-md-6 mb-3"><label className="label-custom">Manual UPI ID</label><input className="form-control input-modern" type="text" value={isManualUPIid} onChange={(e) => setIsManualUPIid(e.target.value)} /></div>
            </div>
            <div className="section-divider"></div>
            <div className="row mt-3">
              <div className="col-md-6 mb-3"><label className="label-custom">UPI Gateway API Key</label><input className="form-control input-modern" type="text" value={UpiGatewayKey} placeholder="Enter API Key from merchant.upigateway.com" onChange={(e) => setUpiGatewayKey(e.target.value)} /></div>
              <div className="col-md-6 mb-3"><label className="label-custom">Return URL (e.g. https://yourdomain.com/return)</label><input className="form-control input-modern" type="text" value={UpiGatewayReturnUrl} placeholder="https://yourdomain.com/return" onChange={(e) => setUpiGatewayReturnUrl(e.target.value)} /></div>
            </div>
          </div>
        </div>

        {/* PAYOUT CONTROLS */}
        <div className="gateway-card">
          <div className="gateway-card-header"><h5>💸 PAYOUT & AUTOPAY CONTROLS</h5></div>
          <div className="form-body">
            <div className="row">
               <div className="col-md-4 mb-3"><label className="label-custom">Max AutoPay Amount (₹)</label><input className="form-control input-modern" type="number" value={maxAutopayAmt} onChange={(e) => setMaxAutopayAmt(e.target.value)} /></div>
            </div>
            <div className="row">
              <div className="col-md-3 mb-3"><label className="label-custom">Manual UPI Payout</label><select className="form-control select-modern" value={isManualPayoutActive} onChange={(e) => setIsManualPayoutActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">Manual Bank Payout</label><select className="form-control select-modern" value={isManualBankPayoutActive} onChange={(e) => setIsManualBankPayoutActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">CashFree Payout</label><select className="form-control select-modern" value={isCashFreePayoutActive} onChange={(e) => setIsCashFreePayoutActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-3 mb-3"><label className="label-custom">MyPay Payout</label><select className="form-control select-modern" value={isMypayPayoutActive} onChange={(e) => setIsMypayPayoutActive(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
            </div>
            <div className="section-divider"></div>
            <div className="row">
              <div className="col-md-4 mb-3"><label className="label-custom">Decentro Auto Payout</label><select className="form-control select-modern" value={isDecentroPayoutAuto} onChange={(e) => setIsDecentroPayoutAuto(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-4 mb-3"><label className="label-custom">MyPay Auto Payout</label><select className="form-control select-modern" value={isMypayPayoutAuto} onChange={(e) => setIsMypayPayoutAuto(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
              <div className="col-md-4 mb-3"><label className="label-custom">RazorPay Auto Payout</label><select className="form-control select-modern" value={isRazorPayPayoutAuto} onChange={(e) => setIsRazorPayPayoutAuto(e.target.value === 'true')}><option value="true">Enabled</option><option value="false">Disabled</option></select></div>
            </div>
          </div>
        </div>

        <button type="submit" className="submit-gateway-btn">
          🚀 Update Gateway Settings
        </button>
      </form>
    </div>
  );
};

export default Gateway;
